
<mat-checkbox  *ngIf="visible" aria-label="label" [checked]="value" [attr.aria-label]="label"
 [disabled]="disabled" (change)="onChange()"><ng-content></ng-content></mat-checkbox>
